<template>
  <div>
    <basic-container>
      <div class="page-container">
        <div class="query-form-wrap">
          <el-form :inline="true" :model="form" :size="formSize">
            <el-form-item>
              <el-select v-model="form.giftId" clearable placeholder="赠品类型">
                <el-option
                  v-for="item in giftTypeOptions"
                  :key="item.id"
                  :label="item.giftName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.status" clearable placeholder="状态">
                <el-option
                  v-for="item in giftStatus"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                filterable
                v-model="form.promotionId"
                collapse-tags
                multiple
                clearable
                placeholder="请选择活动"
              >
                <el-option
                  v-for="item in activityOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <div
                    class="el-option__content"
                    style="padding: 0 30px 0 10px"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.status == 1 ? "上线" : "下线" }}</span
                    >
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                style="width: 200px"
                v-model="form.giftContent"
                clearable
                placeholder="赠品券码/链接"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                style="width: 180px"
                v-model="form.batchNo"
                clearable
                placeholder="批次号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                style="width: 220px"
                v-model="form.leboOrderNum"
                clearable
                placeholder="订单号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                style="width: 180px"
                v-model="form.mobile"
                clearable
                placeholder="手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="领取时间">
              <el-date-picker
                v-model="form.createDateBegin"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择开始时间"
              >
              </el-date-picker
              ><span>&nbsp;——</span>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                value-format="yyyy-MM-dd"
                v-model="form.createDateEnd"
                type="date"
                :picker-options="{
                  disabledDate: (time) => {
                    const begin = new Date(form.createDateBegin);
                    return time.getTime() < begin.getTime();
                  },
                }"
                placeholder="选择结束时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                v-auth="'GIFT_MANAGE_SEARCH'"
                :loading="listLoading"
                icon="el-icon-search"
                type="primary"
                @click="handleSearch"
                >搜索</el-button
              >
              <el-button
                v-auth="'GIFT_MANAGE_ADD'"
                icon="el-icon-plus"
                plain
                type="primary"
                @click="handleOpen"
                >新增</el-button
              >
              <el-button
                v-auth="'GIFT_MANAGE_DELETE'"
                :loading="delLoading"
                icon="el-icon-delete"
                plain
                type="danger"
                @click="handleDelete"
                >删除</el-button
              >
              <el-button
                v-auth="'GIFT_MANAGE_IMPORT'"
                type="success"
                plain
                icon="el-icon-upload2"
                @click="showImport = true"
                >导入</el-button
              >
              <el-button
                v-auth="'GIFT_MANAGE_EXPORT'"
                type="warning"
                plain
                icon="el-icon-download"
                @click="handleExport"
                >导出</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table
            :data="gifts"
            ref="eltable"
            v-loading="listLoading"
            :height="autoTableHeight"
            @selection-change="handleSelect"
            border
            style="width: 100%"
          >
            <el-table-column
              type="selection"
              :selectable="checkStatus"
              fixed
              width="50"
            >
            </el-table-column>
            <el-table-column prop="giftContent" label="券码/链接" width="250">
              <template slot-scope="scope">
                <div class="cell">
                  <span>{{ scope.row.giftContent }}</span>
                  <span
                    class="action-icon"
                    v-auth="'GIFT_MANAGE_DECODE'"
                    v-if="scope.row.giftMode == 1"
                  >
                    <i
                      v-if="scope.row.signed"
                      class="el-icon-document-copy icon"
                      @click="onCopied(scope.row.giftContent)"
                    ></i>
                    <i
                      v-else
                      class="el-icon-view icon"
                      @click="handleDecode(scope.row)"
                    ></i>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="giftName" label="赠品类型" width="180">
            </el-table-column>
            <el-table-column prop="batchNo" label="批次号" width="180">
            </el-table-column>
            <el-table-column prop="leboOrderNum" label="订单号" width="220">
            </el-table-column>
            <el-table-column
              prop="status"
              :formatter="formatStatus"
              label="状态"
              header-align="center"
              align="center"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="expireTime"
              header-align="center"
              align="center"
              label="过期日期"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="promotionName"
              label="赠送活动名称"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="mobile"
              header-align="center"
              align="center"
              label="领取手机号"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="activeTime"
              header-align="center"
              align="center"
              label="领取时间"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="createTime"
              header-align="center"
              align="center"
              label="添加时间"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="updateTime"
              header-align="center"
              align="center"
              min-width="180"
              label="更新时间"
            >
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  :disabled="scope.row.status == 2"
                  v-auth="'GIFT_MANAGE_EDIT'"
                  :size="formSize"
                  type="text"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-pagination">
          <TablePagination
            :page-size.sync="pageConfig.size"
            :total="total"
            :current-page.sync="pageConfig.current"
            @change="handlePageChange"
          />
        </div>
      </div>
    </basic-container>
    <el-dialog
      :title="popupTitle"
      :modal="false"
      :close-on-click-modal="false"
      :visible.sync="showPopups"
      width="500px"
      @close="handleClose"
    >
      <div class="popups-from__wrap">
        <el-form
          :size="formSize"
          ref="form"
          :rules="formRules"
          :model="giftForm"
          label-width="120px"
        >
          <el-form-item label="批次号" prop="batchNo">
            <el-input
              style="width: 300px"
              v-model="giftForm.batchNo"
              placeholder="只能输入数字或字母"
            ></el-input>
          </el-form-item>
          <el-form-item label="赠品类型" prop="giftId">
            <el-select
              style="width: 300px"
              v-model="giftForm.giftId"
              placeholder="请选择赠品类型"
            >
              <el-option
                v-for="item in staticGiftTypeOptions"
                :key="item.id"
                :label="item.giftName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="券码" prop="giftContent">
            <el-input
              style="width: 300px"
              v-model="giftForm.giftContent"
              placeholder="请输入券码"
            ></el-input>
          </el-form-item>
          <el-form-item label="过期日期">
            <el-date-picker
              type="date"
              :picker-options="pickerOptions"
              style="width: 300px"
              value-format="yyyy-MM-dd"
              v-model="giftForm.expireTime"
              placeholder="请选择过期日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :size="formSize" @click="showPopups = false">取消</el-button>
        <el-button
          :loading="submitLoading"
          :size="formSize"
          type="primary"
          @click="handleSubmit"
          >保存</el-button
        >
      </span>
    </el-dialog>
    <import-popups
      @close="showImport = false"
      :visible="showImport"
      :types="staticGiftTypeOptions"
      @success="handleImportSuccess"
    />
  </div>
</template>
<script>
import { merge } from "@/util/common";
import ListMixins from "@/util/mixins/listPage";
import { downloadFile } from "@/util/util";
import { mapActions, mapGetters, mapState } from "vuex";
import ImportPopups from "./importGiftsPopups";
export default {
  name: "GiftManage",
  mixins: [ListMixins],
  components: {
    ImportPopups,
  },
  data() {
    const checkBatchNo = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入批次号"));
      } else if (!/^\w+$/.test(value)) {
        callback(new Error("批次号只能由字母数字组成"));
      } else {
        callback();
      }
    };
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 7);
    return {
      isEdit: false,
      showPopups: false,
      showImport: false,
      form: {
        giftId: "",
        giftContent: "",
        batchNo: "",
        leboOrderNum: "",
        mobile: "",
        promotionId: "",
        status: "",
        createDateBegin: formatDate(start),
        createDateEnd: formatDate(end),
      },
      exportLoading: false,
      listLoading: false,
      submitLoading: false,
      delLoading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      formRules: {
        batchNo: [{ required: true, validator: checkBatchNo, trigger: "blur" }],
        giftId: [
          { required: true, message: "请选择赠品类型", trigger: "blur" },
        ],
        giftContent: [
          { required: true, message: "请输入券码", trigger: "blur" },
        ],
      },
      unmarkCode: "",
      giftForm: {
        id: "",
        batchNo: "",
        giftId: "", // 赠品类型
        giftContent: "",
        expireTime: "",
      },
    };
  },
  computed: {
    ...mapState("runActivityManage", ["total", "suppliers", "activityOptions"]),
    ...mapGetters("app", ["viewportSize"]),
    ...mapGetters("runActivityManage", [
      "giftTypes",
      "giftStatus",
      "gifts",
      "staticGiftTypeOptions",
      "giftTypeOptions",
    ]),
    popupTitle() {
      return this.isEdit ? "编辑" : "新增";
    },
  },
  methods: {
    ...mapActions("runActivityManage", [
      "decode",
      "getDicts",
      "getGiftList",
      "getGiftTypeOptions",
      "submitGiftForm",
      "getActivityOptions",
      "delGifts",
    ]),
    // 确认数据可以操作不
    checkStatus({ status }) {
      return status != 2;
    },
    change(str, index, changeStr) {
      return (
        str.substr(0, index) + changeStr + str.substr(index + changeStr.length)
      );
    },
    // 券码格式处理
    formatCode(row) {
      return (
        <div class="cell">
          <span>{row.giftContent}</span>
          <span class="action-icon">
            {row.signed ? (
              <i
                class="el-icon-document-copy icon"
                onClick={() => this.onCopied(row.giftContent)}
              ></i>
            ) : (
              <i
                class="el-icon-view icon"
                onClick={() => this.handleDecode(row)}
              ></i>
            )}
          </span>
        </div>
      );
    },
    // 加载解密数据
    handleDecode(row) {
      this.decode(row.id).then((res) => {
        row.giftContent = res;
        row.signed = true;
      });
    },
    // 复制数据至剪切板
    onCopied(content) {
      this.$copyText(content).then((_res) => {
        this.$message({ message: "券码已经复制到剪贴板", type: "success" });
      });
    },
    // 导入，导出
    handleExport() {
      const query = merge({}, this.form, this.pageConfig);
      downloadFile("/lebo-partner/partnergiftrecord/export-record", query);
    },
    // 导入成功回调
    handleImportSuccess() {
      this.getList();
    },
    // 格式状态
    formatStatus({ status }) {
      for (let item of this.giftStatus) {
        if (item.dictKey == status) {
          return item.dictValue;
        }
      }
    },
    getList() {
      const query = merge({}, this.form, this.pageConfig);
      query.promotionId = Array.isArray(query.promotionId)
        ? query.promotionId.join(",")
        : "";
      this.getGiftList(query);
    },
    // 编辑数据
    handleEdit(row) {
      this.decode(row.id).then((res) => {
        this.giftForm.giftContent = res;
      });
      for (let key of Object.keys(this.giftForm)) {
        this.giftForm[key] = row[key].toString();
      }
      this.isEdit = true;
      this.handleOpen();
    },
    // 删除数据
    handleDelete() {
      if (this.selectedRows.length > 0) {
        this.$confirm("确定要删除选择的记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          const ids = this.selectedRows.map((item) => item.id).join(",");
          this.delLoading = true;
          this.delGifts({ ids })
            .then((isSuccess) => {
              if (isSuccess) {
                this.selectedRows = [];
                this.getList();
              }
            })
            .finally(() => {
              this.delLoading = false;
            });
        });
      } else {
        this.$alert("请选择要删除的记录", "提示", {
          confirmButtonText: "知道了",
        });
      }
    },
    // 打开编辑窗口
    handleOpen() {
      this.showPopups = true;
    },
    // 保存数据
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const query = merge({}, this.giftForm);
          if (!this.isEdit) {
            delete query.id;
          }
          this.submitLoading = true;
          this.submitGiftForm(query)
            .then((isSuccess) => {
              if (isSuccess) {
                this.showPopups = false;
                this.getList();
              }
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    handleClearForm() {
      for (let key in this.giftForm) {
        this.giftForm[key] = "";
      }
    },
    handleClose() {
      this.handleClearForm();
    },
  },
  created() {
    const { id, status } = this.$route.query;
    id && (this.form.giftId = id);
    status && (this.form.status = status);
    this.getDicts("GIFT_CATEGORY");
    this.getDicts("GIFT_STATUS");
    this.getActivityOptions();
    this.getGiftTypeOptions();
    this.getList();
  },
};
</script>
<style lang="scss">
.table-pagination {
  margin-top: 20px;
  text-align: right;
}

.table-wrap .action-icon {
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 10px;
}
</style>
